import { FC, Fragment } from 'react';
import ProductHeader from '../ProductHeader';
import CommonCardA from '../CommonCardA';
import { useProductList2 } from '../utils';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { ProductModule } from '@/components/MembersDay/type';

export interface IProductProps {
    module: ProductModule;
    title: string;
    subtitle: string;
}

const Accessories: FC<IProductProps> = ({ module, title, subtitle }) => {
    const { locale } = getLocal();
    const { productList } = useProductList2(module, locale);

    return (
        <div className={styled.Accessories}>
            <ProductHeader title={title} subtitle={subtitle} />
            <div className={`members-store-inter`}>
                {productList.map((item, index: number) => {
                    return (
                        <Fragment key={index}>
                            <CommonCardA data={item} list_name={title} module={module} />
                        </Fragment>
                    );
                })}
            </div>
        </div>
    );
};

export default Accessories;
